module.exports = __webpack_public_path__ + "img/logo_big.592be45e.png";